import { H2 } from 'components/Typography'
import { useAppSelector } from 'app/hooks'
//import { MIST_CLOUD_URL } from 'app/consts'
import { WhiteBlock } from 'components/Layout'
import CreateWLANsActions from '../../NetworkWizard/CreateWLANs/CreateWLANsActions'
import NetworkStatusSubscription from './NetworkStatusSubscription'
import NetworkStatusWLANs from './NetworkStatusWLANs'
import NetworkStatusClients from './NetworkStatusClients'
import NetworkGraph from './NetworkGraph'
import { claimDevicesFetchDataSelector } from 'features/networkAi/selectors'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import {
  NetworkStatusContainer,
  NetworkStatusHeader,
  VisitMistButton,
  NetworkStatusItem,
  NetworkStatusBody,
  NetworkIntroBody,
} from './styles'
import { useIntl } from 'react-intl'
import { network } from 'features/networkAi/messages'
import {
  useNetworkHomeJobsRouteParams,
  useCurrentHomeSiteId,
} from 'features/networkAi/hooks'
import { mistOrganizationIdSelector } from 'features/networkAi/selectors'

// TODO: localization
function NetworkStatus() {
  const { homeId } = useNetworkHomeJobsRouteParams()
  const siteId = useCurrentHomeSiteId({ homeId })

  const claimDevices = useAppSelector(claimDevicesFetchDataSelector.data)
  const { formatMessage } = useIntl()
  const organizationId = useAppSelector(mistOrganizationIdSelector)

  const buildMistUrl = `https://manage.ac2.mist.com/admin/?org_id=${organizationId}#!dashboard/siteComparison/capacity/-/_/today/${
    Date.now() - 86400
  }/${Date.now()}`

  return (
    <StyledFadeInWrapper>
      <NetworkStatusContainer>
        <NetworkStatusHeader>
          <H2>{formatMessage(network.title)}</H2>
          <VisitMistButton
            as="a"
            href={buildMistUrl}
            target="_blank"
            type="button"
            variant="secondary"
          >
            Go To Mist Cloud
          </VisitMistButton>
        </NetworkStatusHeader>

        {claimDevices?.length === 0 && claimDevices !== null && (
          <WhiteBlock>
            <NetworkIntroBody>
              {formatMessage(network.introMessage)}
            </NetworkIntroBody>
          </WhiteBlock>
        )}

        <WhiteBlock>
          <NetworkStatusSubscription />
        </WhiteBlock>

        {siteId !== '' &&
          claimDevices?.length !== 0 &&
          claimDevices !== null && (
            <NetworkStatusBody>
              <NetworkStatusItem>
                <NetworkStatusWLANs />
              </NetworkStatusItem>
              <NetworkStatusItem>
                <NetworkStatusClients />
              </NetworkStatusItem>
            </NetworkStatusBody>
          )}

        {siteId !== '' &&
          claimDevices?.length !== 0 &&
          claimDevices !== null && (
            <NetworkStatusBody>
              <NetworkGraph />
            </NetworkStatusBody>
          )}

        {siteId !== '' && claimDevices !== null && <CreateWLANsActions />}
      </NetworkStatusContainer>
    </StyledFadeInWrapper>
  )
}

export default NetworkStatus
